export default "__VITE_ASSET__DgrsMgne__"